module.exports = __webpack_public_path__ + "static/card-search-heart-6d3f0f597ab612c34edb2d7856d1c07e.svg";